import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_file_status = (id, status) => {
  return api.post(`${ApiEndpointConstants.MODIFYMODELSTATUS}`, {
    id,
    status,
  });
};
